<template>
    <v-dialog v-model="show" max-width="768">
        <form v-on:submit.prevent="prevent"> 
        <v-card class="pa-6" :loading="loading">
            <v-card-title class="py-6 d-flex justify-space-between"><div class="text-h5 accent--text font-weight-bold">Descreva o motivo da recusa da Grid #000</div>
                <v-btn
                icon
                @click="show = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn></v-card-title>
            <v-card-text>
                <v-textarea placeholder="Descreva aqui..." counter="500"
                required
                :error-messages="reasonErrors"
        @input="v$.reason.$touch()"
        @blur="v$.reason.$touch()"
        @keyup.enter="submit"
        v-model="reason"
        ></v-textarea>
            </v-card-text>
            <v-card-actions class="v-card__actions d-flex justify-end pt-3 pb-3 px-6">
                <v-btn large color="red" elevation="0" type="button" @click="submit" :disabled="v$.$invalid && v$.reason.$dirty" :loading="processing" class="white--text">Recusar Grid</v-btn>
            </v-card-actions>
        </v-card>
        </form>
    </v-dialog>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import { required, minLength } from '@vuelidate/validators'
    export default {
        setup () {
            return { v$: useVuelidate() }
        },
        validations: {
            reason: { required, minLength: minLength(10) },        
        },
        props: {
            open: Boolean
        },
        data: () => ({
            loading: false,
            processing: false,
            show: true,
            reason: ""
        }),
        computed: {
            reasonErrors () {
                const errors = []
                if (!this.v$.reason.$dirty) return errors

                this.v$.reason.minLength.$invalid && errors.push('O motivo da recusa deve conter ao menos 10 caracteres.')
                this.v$.reason.required.$invalid && errors.push('O motivo da recusa é obrigatório.')
                return errors
            },
        },
        methods: {
            submit(){
                this.v$.$touch()
                if(!this.v$.$invalid){
                    alert('enviar')
                }
            },
            prevent(event){
          event.stopPropagation()
        },
        
        }
    }
</script>